import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useV3BudgetTemplate from '../hooks/useV3BudgetTemplate';
import EditBudgetTemplateUI from './EditBudgetTemplateUI';

const V3BudgetTemplateEditDrawer = ({ team, templateId, open, onClose, csrfToken, currentUser }) => {
  const api = useV3BudgetTemplate({ team, templateId, csrfToken });
  const { budget, load } = api;

  useEffect(() => {
    if (!open || !templateId) return undefined;
    load();
    return undefined;
  }, [open, templateId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!open) return null;

  // budget can be the PREVIOUS templateId's data: the hook (and its `budget`
  // state) lives above `if (!open) return null`, so it survives close/reopen
  // and a templateId swap until the new GET resolves. Never render
  // EditBudgetTemplateUI (or read the name/usage) off it unless its id
  // actually matches the template we're supposed to be showing.
  const current = budget && String(budget.id) === String(templateId) ? budget : null;
  const usage = current?.used_by_event_template_count || 0;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(10,13,18,.45)', display: 'flex', justifyContent: 'flex-end', zIndex: 1050 }}>
      <div className="v3-edit-drawer-scrim" onClick={onClose} />
      <div className="v3-edit-drawer-panel" style={{ width: 980, maxWidth: '96vw' }}>
        <div className="v3-edit-drawer-header">
          <div style={{ minWidth: 0, flex: 1 }}>
            <span className="v3-edit-drawer-eyebrow">Event template › budget template</span>
            <h2 className="v3-edit-drawer-title">{current?.name || 'Loading…'}</h2>
          </div>
          <button type="button" className="v3-edit-drawer-close" onClick={onClose} aria-label="Close"><i className="far fa-times" /></button>
        </div>
        {usage > 0 ? (
          <div className="v3-edit-drawer-usage-banner">
            This budget template is used by {usage} event template{usage === 1 ? '' : 's'}. Saving changes it for all of them.
          </div>
        ) : null}
        <div className="v3-edit-drawer-body">
          {!current && <div className="v3-edit-drawer-empty">Loading…</div>}
          {current && (
            <EditBudgetTemplateUI
              key={templateId}
              team={team}
              currentUser={currentUser}
              csrfToken={csrfToken}
              api={api}
            />
          )}
        </div>
        <div className="v3-edit-drawer-footer">
          <button type="button" className="v3-origin-button" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

V3BudgetTemplateEditDrawer.propTypes = {
  team: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired }).isRequired,
  templateId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  csrfToken: PropTypes.string,
  currentUser: PropTypes.object,
};

export default V3BudgetTemplateEditDrawer;
